
<app-select-sections [(options)]="options" [planOfAction]="planOfAction"></app-select-sections>

<dw-message [(message)]="message"></dw-message>